var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreEssentials1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 18.5H26C26.1989 18.5 26.3897 18.579 26.5303 18.7197C26.671 18.8603 26.75 19.0511 26.75 19.25V26.75C26.75 26.9489 26.671 27.1397 26.5303 27.2803C26.3897 27.421 26.1989 27.5 26 27.5H14C13.8011 27.5 13.6103 27.421 13.4697 27.2803C13.329 27.1397 13.25 26.9489 13.25 26.75V19.25C13.25 19.0511 13.329 18.8603 13.4697 18.7197C13.6103 18.579 13.8011 18.5 14 18.5H14.75V17.75C14.75 17.0606 14.8858 16.3779 15.1496 15.7409C15.4135 15.104 15.8002 14.5252 16.2877 14.0377C16.7752 13.5502 17.354 13.1635 17.9909 12.8996C18.6279 12.6358 19.3106 12.5 20 12.5C20.6894 12.5 21.3721 12.6358 22.0091 12.8996C22.646 13.1635 23.2248 13.5502 23.7123 14.0377C24.1998 14.5252 24.5865 15.104 24.8504 15.7409C25.1142 16.3779 25.25 17.0606 25.25 17.75V18.5ZM14.75 20V26H25.25V20H14.75ZM19.25 21.5H20.75V24.5H19.25V21.5ZM23.75 18.5V17.75C23.75 16.7554 23.3549 15.8016 22.6517 15.0983C21.9484 14.3951 20.9946 14 20 14C19.0054 14 18.0516 14.3951 17.3483 15.0983C16.6451 15.8016 16.25 16.7554 16.25 17.75V18.5H23.75Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreEssentials1);
export default __webpack_public_path__ + "static/media/core_essentials1.1b9f8d58289c7906cfa58f1e3a8ba646.svg";
export { ForwardRef as ReactComponent };